import bowser from 'bowser';
import {CONFIG} from '../app/config/config';

const isValidUserBrowser = bowser.check(CONFIG.LIBRARIES.SUPPORTED_BROWSERS);

if (!isValidUserBrowser) {
    window.open('browsers.html', '_self');
}



// WEBPACK FOOTER //
// ./src/browsers/supported.js